import {Component, input, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {CurrentWeather, Weather} from "../../model/weather.model";
import {WeatherService} from "../../service/weather.service";
import {CalcWeatherIconParams} from "../../model/calc-weather-icon-params.interface";
import {NavController} from "@ionic/angular";
import {FirebaseEventEnum} from "../../enum/firebase-event.enum";
import {FirebaseService} from "../../service/firebase.service";
import {APP_CONFIG_PARAMS} from "../../const/app-config";
import * as moment from "moment";
import {of} from "rxjs";
import {weatherClassType} from "../../model/weather-calc-info.model";

@Component({
  selector: 'app-weather-info-card',
  templateUrl: './weather-info-card.component.html',
  styleUrls: ['./weather-info-card.component.scss'],
})
export class WeatherInfoCardComponent implements OnInit {

  weather = input<Weather>();

  european_aqi: number;
  airQualityIcon: string;
  serviceBoxIcon: any;
  currentWeather: CurrentWeather;
  loaded: boolean;

  label: string;
  wClass: weatherClassType;
  params: CalcWeatherIconParams;
  airQualityLabel: AirQualityLabel;

  constructor(public weatherService: WeatherService,
              private firebaseService: FirebaseService,
              private navCtrl: NavController) {
  }

  ngOnInit() {
    this._initWeather();
  }

  onOpenDetail() {
    this.navCtrl.navigateForward(['/weather']);
    this.firebaseService.logEvent(FirebaseEventEnum.CLICK_WEATHER_WIDGET, {
      click_weather_widget: 'selezionato'
    });
  }

  _calculateAirQualityLabel(europeanAqi: number): AirQualityLabel {

    if (europeanAqi <= 40) {
      this.airQualityIcon = 'assets/icon/air-quality/ic_face_48_green.svg';
      this.serviceBoxIcon = 'air-quality_Buono';
      return "Buono";
    } else if (europeanAqi <= 80) {
      this.airQualityIcon = 'assets/icon/air-quality/ic_face_48_yellow.svg';
      this.serviceBoxIcon = 'air-quality_Moderato';
      return "Moderato";
    } else {
      this.airQualityIcon = 'assets/icon/air-quality/ic_face_48_red.svg';
      this.serviceBoxIcon = 'air-quality_Pessimo';
      return "Pessimo";
    }

  }

  private _initWeather() {
    this.loaded = false;
    this._getWeather$().subscribe((res: Weather) => {
      setTimeout(() => {

        this.currentWeather = res.currentWeather;
        this.european_aqi = this.currentWeather.airQuality.current.european_aqi;

        this._calculateCurrentWeather(res);

        console.log(this.currentWeather);
        this.loaded = true;

        const {precipitation, precipitationProbability, cloudCover, windSpeed, isDay} = this.currentWeather;

        this.params = {
          precipitation,
          precipitationProbability,
          cloudCover,
          windSpeed,
          isDay
        };

        const style = this.weatherService.calculateWeatherStyle(this.params);
        this.label = style.label;
        this.wClass = style.wClass;
        this.airQualityLabel = this._calculateAirQualityLabel(this.currentWeather.airQuality?.current?.european_aqi);


      }, APP_CONFIG_PARAMS.SKELETON_TIMEOUT);
    });
  }

  private _getWeather$(){
    if(this.weather()){
      return of(this.weather());
    } else {
      return this.weatherService.getWeather();
    }
  }

  private _calculateCurrentWeather(res: Weather) {

    const now = moment(); // data/ora attuale
    const slot = res?.dailyForecast.find(item => moment(item.date).isSame(now, 'days'))?.hourlyForecast?.find(item => moment(item.time).isSameOrAfter(now));

    this.currentWeather.precipitation = slot?.precipitationProbability;
  }

}

type AirQualityLabel = 'Buono' | 'Moderato' | 'Scadente' | 'Pessimo' | 'Molto_pessimo';
